/* Shared geography for the journey scene (WebGL) and its 2D fallback.
   Plain equirectangular with a cos(30°) squeeze: honest enough at this scale. */

export const CENTER = { lon: 71, lat: 23 };
const KX = Math.cos((30 * Math.PI) / 180);

export const project = (lon, lat) => [(lon - CENTER.lon) * KX, lat - CENTER.lat];

export const CITIES = {
  yiwu: [120.07, 29.31],
  guangzhou: [113.26, 23.13],
  istanbul: [28.98, 41.01],
  gaziantep: [37.38, 37.07],
  aleppo: [37.16, 36.2],
  damascus: [36.29, 33.51],
  latakia: [35.78, 35.52],
};

/* Which cities each chapter puts a label on. */
export const CHAPTER_LABELS = [
  ["yiwu", "guangzhou", "istanbul"],
  ["istanbul"],
  ["istanbul", "guangzhou", "damascus"],
  ["gaziantep", "aleppo"],
  ["aleppo", "damascus"],
];

export const ROUTES = {
  // Istanbul → Ankara → Adana → Gaziantep → Bab al-Salama → Aleppo → Homs → Damascus
  road: [
    [28.98, 41.01], [30.5, 40.6], [32.86, 39.93], [34.2, 38.6], [35.32, 37.0],
    [36.4, 37.05], [37.38, 37.07], [37.1, 36.62], [37.16, 36.2], [36.9, 35.4],
    [36.72, 34.73], [36.5, 34.1], [36.29, 33.51],
  ],
  // Guangzhou → Malacca → Indian Ocean → Bab el-Mandeb → Suez → Latakia → Damascus
  sea: [
    [113.26, 23.13], [114.2, 20.5], [111.5, 14], [108, 7], [104.2, 1.6], [100.5, 3.5],
    [96.5, 6], [88, 6.2], [80.5, 5.2], [72, 9], [62, 12.8], [51, 12.6], [44.5, 12.2],
    [43.2, 13.4], [40.5, 17], [37.5, 21.5], [34.8, 26.5], [32.6, 29.8], [32.3, 31.4],
    [33.5, 33.2], [35.7, 35.5], [36.3, 34.9], [36.72, 34.73], [36.29, 33.51],
  ],
  // Yiwu → Damascus by air (lifted into an arc in 3D)
  air: [[120.07, 29.31], [36.29, 33.51]],
};

/* Camera keyframes per chapter: look-at (lon, lat), distance, tilt (rad). */
export const KEYFRAMES = [
  { lon: 112, lat: 28, dist: 34, tilt: 0.78 }, // pickup — China
  { lon: 31, lat: 39.5, dist: 30, tilt: 0.85 }, // warehouse — Istanbul
  { lon: 76, lat: 25, dist: 132, tilt: 0.58 }, // on the way — whole network
  { lon: 37.3, lat: 36.6, dist: 21, tilt: 0.9 }, // customs — Türkiye/Syria border
  { lon: 36.8, lat: 34.9, dist: 26, tilt: 0.84 }, // delivery — Aleppo & Damascus
];

/* When each route draws itself, in overall scroll progress (0..1). */
export const ROUTE_WINDOWS = {
  road: [0.18, 0.62],
  sea: [0.3, 0.62],
  air: [0.36, 0.56],
};
